import React from "react";
import "./Blue_Btn.css";
import { Button } from "react-bootstrap";

const Blue_Btn = ({ btnText, onClick }) => {
  return (
    <button className="Blue_Btn" onClick={onClick}>
      {btnText}
    </button>
  );
};

export default Blue_Btn;
